import { render } from "./MyPageQna.vue?vue&type=template&id=41a5edef"
import script from "./MyPageQna.vue?vue&type=script&lang=js"
export * from "./MyPageQna.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__